module.exports = __webpack_public_path__ + "static/media/page_02.856121fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/page_02.jpg
// module id = 1828
// module chunks = 0 1